import api from "./Api";

class TipoPedidoService {
  GetTipoPedido(payload) {
    return api.get("/v1/tipoPedido/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTipoPedido(payload) {
    return api.post("/v1/tipoPedido/", payload).then((response) => {
      return response.data;
    });
  }

  PutTipoPedido(payload) {
    return api.put("/v1/tipoPedido/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTipoPedido(payload) {
    return api.delete("/v1/tipoPedido/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTipoPedidoOData(payload) {
    return api.get("/OData/TipoPedido" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TipoPedidoService();
